import enumeration from '../../../../src/Shared/Util/enumeration';

const ReservedValue = enumeration(['ALPHANUMERIC', 'BACKSPACE', 'DIACRITICS', 'SPACE', 'GAP']);

type TReservedValue = typeof ReservedValue[keyof typeof ReservedValue];

export type {TReservedValue};
export {ReservedValue as default};
